module.exports = __webpack_public_path__ + "img/19.24b62192.png";